import { useStore } from "../store";

export const useAppSettings = () => {
  const [_, setState] = useStore();

  const readAppSettings = async () => {
    const headers = new Headers();
    headers.append("pragma", "no-cache");
    headers.append("cache-control", "no-cache");

    fetch("/appSettings.json", {
      method: "GET",
      headers
    })
      .then(response => response.json())
      .then(settings => {
        setState(old => ({
          ...old,
          settings
        }));
      })
      .catch(error => {
        console.error("Error reading config", error);
      });
  };

  return { readAppSettings };
};
